import { useCallback, useEffect } from "react"

const THRESHOLD_PX = 200

// Fetches the next page as the window approaches the bottom of the document.
// Pairs with useDatatable({ infinite: true }) for full-page tables that have no
// inner scroll container of their own.
const useInfiniteScrollTrigger = ({
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  enabled = true,
}) => {
  const maybeFetchNextPage = useCallback(() => {
    if (!enabled || !hasNextPage || isFetchingNextPage) return

    const { scrollHeight, scrollTop, clientHeight } =
      document.scrollingElement || document.documentElement
    if (scrollHeight - scrollTop - THRESHOLD_PX <= clientHeight) fetchNextPage()
  }, [enabled, hasNextPage, isFetchingNextPage, fetchNextPage])

  useEffect(() => {
    window.addEventListener("scroll", maybeFetchNextPage)
    window.addEventListener("resize", maybeFetchNextPage)

    // Covers a page whose content doesn't fill the viewport, where no scroll
    // event can ever fire.
    maybeFetchNextPage()

    return () => {
      window.removeEventListener("scroll", maybeFetchNextPage)
      window.removeEventListener("resize", maybeFetchNextPage)
    }
  }, [maybeFetchNextPage])
}

export default useInfiniteScrollTrigger
